'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _taggedTemplateLiteral2 = require('babel-runtime/helpers/taggedTemplateLiteral');

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  width: ', ';\n  text-align: left;\n  transition: all 0.2s ease;\n  cursor: pointer;\n  margin-bottom: ', ';\n  border-bottom: ', ';\n  border-bottom-width: 4px;\n'], ['\n  width: ', ';\n  text-align: left;\n  transition: all 0.2s ease;\n  cursor: pointer;\n  margin-bottom: ', ';\n  border-bottom: ', ';\n  border-bottom-width: 4px;\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _themeProps = require('@hixme-ui/theme-props');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LineTab = _styledComponents2.default.div(_templateObject, function (props) {
  return props.width || 'auto';
}, function (props) {
  return props.marginBottom || '4px';
}, function (props) {
  if (props.active) return '4px solid ' + (0, _themeProps.getTextColor)(props);
  return '4px solid rgba(0, 0, 0, 0)';
});

exports.default = LineTab;
//# sourceMappingURL=LineTab.js.map


//////////////////
// WEBPACK FOOTER
// ../tabs/lib/tab-types/LineTab.js
// module id = 762
// module chunks = 0